// extracted by mini-css-extract-plugin
export default {"icon":"DashboardCard_icon__tPUOJ","title":"DashboardCard_title__Uyixr","number":"DashboardCard_number__tg4ie","button":"DashboardCard_button__79+U+"};